import axiosClient, { ApiResponse, axiosCustomError } from "./axiosClient"
import { ILanguage } from "./LanguageService"

export interface ITicketClassTranslation {
    ticketId: number | null
    languageId: number
    name: string
    description: string
    language: ILanguage
}

export interface ITicketClass {
    id: number | null
    name: string
    color: string
    price: number | null
    currency: string
    quantity: number | null
    orderNumber: number | null
    isUsed: boolean
    eventId: number
    translations: Array<ITicketClassTranslation>
}

export default class TicketClassService {
    static async listAll(eventId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/TicketClasses/${eventId}/All`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async filter(eventId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/TicketClasses/${eventId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async get(eventId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/TicketClasses/${eventId}/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async delete(eventId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/TicketClasses/${eventId}/${id}`, {

            })

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async update(eventId: number, id: number, itemData: ITicketClass) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/TicketClasses/${eventId}/${id}`, itemData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async create(eventId: number, itemData: ITicketClass) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/TicketClasses/${eventId}/Create`, itemData)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }

    static async changeIsUsed(eventId: number, id: number) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/TicketClasses/${eventId}/ChangeIsUsed/${id}`)

            return data
        } catch (error) {
            return axiosCustomError(error)
        }
    }
}